import React, { useState } from 'react';
import { MetaradarStateSnapshot } from '@app/model/metaradar/MetaradarStateSnapshot';
import DataProvider from '@app/model/_common/DataProvider';
import Message from '@app/component/message/Message';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import { findProviderData } from '@app/component/provider/FindProviderData';
import MetaradarGraphUndercutsPerRegionForProviderFragment
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__metaradar/fragment/MetaradarGraphUndercutsPerRegionForProviderFragment';
import _isEmpty from 'lodash/isEmpty';

const MetaradarGraphUndercutsPerRegionForProvidersFragment: React.FunctionComponent<{
	metaradarStateSnapshot: MetaradarStateSnapshot
}> = ({ metaradarStateSnapshot }) => {

	const { companyHotel } = useSelectedCompanyHotel();

	if (!metaradarStateSnapshot) {
		return <div className="p-6"><Message state="info">No results found!</Message></div>;
	}

	const statistics = metaradarStateSnapshot.findStatisticsPerProvider(companyHotel.metaradarSettings!.threshold || 0.9);

	if (_isEmpty(statistics)) {
		return <div className="p-6"><Message state="info">No results found!</Message></div>;
	}

	const sortedProviders = statistics!.sort((a, b) => b.percentageOfTotalUndercuts - a.percentageOfTotalUndercuts)
		.map((stat) => stat.provider);


	return <MetaradarGraphUndercutsPerRegionForProviders metaradarStateSnapshot={metaradarStateSnapshot} sortedProviders={sortedProviders}/>;
};

const MetaradarGraphUndercutsPerRegionForProviders: React.FunctionComponent<{metaradarStateSnapshot: MetaradarStateSnapshot, sortedProviders: DataProvider[]}> = ({metaradarStateSnapshot, sortedProviders}) => {
	const [currentProvider, setCurrentProvider] = useState<DataProvider>(sortedProviders[0]);

	const onSelectProvider = (provider: DataProvider | string) => {
		// @ts-ignore
		setCurrentProvider(provider)
	}

	return <>
		<div className="mb-6">
			<div className="grid grid-cols-1 sm:hidden p-6">
				<select aria-label="Select a tab" className="col-start-1 row-start-1 w-full input" onChange={(event) => onSelectProvider(event.target.value)}>
					{sortedProviders.map(provider => <option key={'option_' + provider}
																									 value={provider}>{findProviderData(provider).name}</option>)}
				</select>
			</div>
			<div className="hidden sm:block p-6">
				<div className="border-b border-gray-200">
					<nav className="-mb-px flex" aria-label="Tabs">
						{sortedProviders.map(provider => <a key={'nav_' + provider} onClick={() => onSelectProvider(provider)}
																								className={`whitespace-nowrap border-b-2 px-3 py-1.5 text-sm font-medium cursor-pointer ${provider === currentProvider ? 'border-blue-500 text-blue-600' : 'text-gray-500 hover:border-gray-300 hover:text-gray-700'}`}>
							{findProviderData(provider).name}
						</a>)}
					</nav>
				</div>
			</div>
			<MetaradarGraphUndercutsPerRegionForProviderFragment metaradarStateSnapshot={metaradarStateSnapshot} provider={currentProvider}/>
		</div>

	</>;
}


export default  MetaradarGraphUndercutsPerRegionForProvidersFragment;